import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function RelatedCard({ item }) {
  return (
    <div className="blog-related-card">
      {/* LEFT: IMAGE */}
      <Link to={`/blog/${item?.slug}`} className="blog-related-img-wrap">
        <img src={item?.image} alt={item?.title} className="blog-related-img" />
        <div className="blog-related-img-overlay" />
      </Link>

      {/* RIGHT: CONTENT */}
      <div className="blog-related-content">
        {item?.createdAt && (
          <span className="blog-related-date">{getDateAgo(item.createdAt)}</span>
        )}

        <Link to={`/blog/${item?.slug}`} className="blog-related-title">
          {item?.title}
        </Link>

        <p className="blog-related-desc">{item?.shortDescription}</p>

        <Link to={`/blog/${item?.slug}`} className="blog-related-read">
          Read more
          <svg viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.5" width="11" height="11">
            <path d="M1 6.5h11M7 1l5.5 5.5L7 12" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default RelatedCard;